import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-clear-all-btn',
  templateUrl: './clear-all-btn.component.html',
  styleUrls: ['./clear-all-btn.component.scss']
})
export class ClearAllBtnComponent {
  @Output() public btnClick = new EventEmitter();
}
